export default {
  dialog: {
    search: "Rechercher",
    placeholder: "Rechercher...",
    results: "Résultats",
    tags: {
      installer: "Installateur",
      householder: "Propriétaire",
      "help-center": "Centre d'aide",
      blog: "Blog",
    },
  },
  title: "Bonjour ! Comment pouvons-nous vous aider ?",
  subtitle: "",
  placeholder: "Rechercher dans aide et assistance",
}
